import type { Region } from "config/backend";

/**
 * Shared non-prod collector (int-sbx, uat, staging).
 * @see https://procoretech.atlassian.net/wiki/spaces/CSE/pages/3300065546/Sending+Data+to+OpenTelemetry
 */
const OTEL_NONPROD_COLLECTOR = "https://otlp.collector.ops.procoretech-qa.com";

/**
 * OTLP collector base URL per region. Also imported by vite.config.ts for the dev `/otel` proxy, so this
 * module must have no runtime imports.
 */
export const OTEL_COLLECTORS = {
    staging: OTEL_NONPROD_COLLECTOR,
    "int-sbx": OTEL_NONPROD_COLLECTOR,
    uat: OTEL_NONPROD_COLLECTOR,
    us01: "https://otlp.collector.ops.na-east-01.procoretech.com",
    us02: "https://otlp.collector.ops.na-west-02.procoretech.com",
    uk01: "https://otlp.collector.ops.na-east-01.procoretech.com",
    eu01: "https://otlp.collector.ops.na-east-01.procoretech.com",
} as const satisfies Record<Exclude<Region, "local">, string>;

/** Jaeger from docker-compose.telemetry.yml. `127.0.0.1` rather than `localhost` so Node doesn't also try `::1`. */
export const OTEL_LOCAL_COLLECTOR = "http://127.0.0.1:4318";
